import { render } from "./OpenScreen.vue?vue&type=template&id=4e47016a&scoped=true"
import script from "./OpenScreen.vue?vue&type=script&lang=js"
export * from "./OpenScreen.vue?vue&type=script&lang=js"

import "./OpenScreen.vue?vue&type=style&index=0&id=4e47016a&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e47016a"]])

export default __exports__